// extracted by mini-css-extract-plugin
export var animated = "product-scan-module--animated--587ba";
export var categoryTag = "product-scan-module--categoryTag--b50fb";
export var centered = "product-scan-module--centered--ee15e";
export var cta = "product-scan-module--cta--b12ea";
export var headerImage = "product-scan-module--headerImage--33a1a";
export var headline = "product-scan-module--headline--ef877";
export var introCopy = "product-scan-module--introCopy--be026";
export var invalid = "product-scan-module--invalid--b4fff";
export var linkButton = "product-scan-module--linkButton--708dc";
export var manualEntry = "product-scan-module--manualEntry--6fa0c";
export var manualEntryInput = "product-scan-module--manualEntryInput--ee6f6";
export var pill = "product-scan-module--pill--6e79b";
export var productCard = "product-scan-module--productCard--5fd83";
export var productImage = "product-scan-module--productImage--c1293";
export var pulse = "product-scan-module--pulse--90da7";
export var rewardCard = "product-scan-module--rewardCard--1e3ae";
export var rewardCta = "product-scan-module--rewardCta--475ec";
export var root = "product-scan-module--root--824d8";
export var scanBox = "product-scan-module--scanBox--7a05f";
export var scanBrackets = "product-scan-module--scanBrackets--387fa";
export var scanCorners = "product-scan-module--scanCorners--da70b";
export var scannerError = "product-scan-module--scannerError--f0aa9";
export var screenTitle = "product-scan-module--screenTitle--8e294";
export var skip = "product-scan-module--skip--762ee";
export var splashStepIcon = "product-scan-module--splashStepIcon--b6542";
export var splashStepRow = "product-scan-module--splashStepRow--838d1";
export var splashStepText = "product-scan-module--splashStepText--237f5";
export var splashStepTitle = "product-scan-module--splashStepTitle--3f5fc";
export var splashSteps = "product-scan-module--splashSteps--93761";
export var srOnly = "product-scan-module--srOnly--5aa19";
export var step = "product-scan-module--step--873ad";
export var successMark = "product-scan-module--successMark--d9dfc";
export var unlockLabel = "product-scan-module--unlockLabel--d53fd";
export var unlockRow = "product-scan-module--unlockRow--26a33";
export var unlockValue = "product-scan-module--unlockValue--c4cd4";
export var video = "product-scan-module--video--6e9bc";
export var viewportWrap = "product-scan-module--viewportWrap--07be9";